import AutoSuggest from "@components/common/AutoSuggest";
import { Tag } from "nectar-ui";
import React, { useCallback, useState } from "react";
import { loadCustomersSuggestion } from "@services/suggestService";

import { CustomerFilterContainer, TagContainer } from "../style";
import { SimplyfiedContact } from "@customTypes/user/contact";
import { RawSuggestion, Suggestion } from "@customTypes/autosuggest";

const parseSuggestions = (
  rawSuggestions: RawSuggestion[],
  selectedCustomers: SimplyfiedContact[]
) => {
  const customerIds = selectedCustomers.map((selectedCustomer) => selectedCustomer.id);
  const filteredSuggestions = rawSuggestions.filter(
    (rawSuggestion) => !customerIds.includes(rawSuggestion.objectId)
  );

  const parsedSuggestions = filteredSuggestions.map((suggestion) => ({
    name: suggestion.title,
    value: suggestion.objectId,
  }));

  return parsedSuggestions;
};

type DashboardChartCustomerFilterProps = {
  setCustomerFunction: (newList: React.SetStateAction<SimplyfiedContact[]>) => void;
  selectedCustomers: SimplyfiedContact[];
};

const DashboardChartCustomerFilter: React.FC<DashboardChartCustomerFilterProps> = ({
  setCustomerFunction,
  selectedCustomers,
}) => {
  const [suggestionList, setSuggestionList] = useState([]);

  const handleCloseTag = (selectedClient: SimplyfiedContact) => () => {
    setCustomerFunction((currentClientList) => {
      return currentClientList.filter((client) => client.id !== selectedClient.id);
    });
  };

  const fetchSuggestions = useCallback(
    async (value: string) => {
      const response = await loadCustomersSuggestion(value);
      return parseSuggestions(response.data.resultList, selectedCustomers);
    },
    [selectedCustomers]
  );

  const handleChange = async (value: string) => {
    if (!value) {
      if (suggestionList) setSuggestionList(undefined);
      return;
    }
    const parsedSuggestions = await fetchSuggestions(value);
    setSuggestionList(parsedSuggestions);
  };

  const handleSelect = (selection: Suggestion) => {
    setCustomerFunction((currentCustomerList) => {
      const newCustomer = { name: selection.name, id: selection.value };
      setSuggestionList([]);
      const customerSet = new Set([...currentCustomerList, newCustomer]);
      return Array.from(customerSet);
    });
  };

  return (
    <CustomerFilterContainer>
      <AutoSuggest
        suggestionList={suggestionList}
        onChange={handleChange}
        onSelect={handleSelect}
        disabled={selectedCustomers.length > 7}
        placeholder="Digite e selecione o nome do cliente"
      />
      <TagContainer>
        {selectedCustomers.length > 0 &&
          selectedCustomers.map((selectedCustomer) => (
            <Tag key={selectedCustomer.name} closeTag={handleCloseTag(selectedCustomer)}>
              {selectedCustomer.name}
            </Tag>
          ))}
      </TagContainer>
    </CustomerFilterContainer>
  );
};

export default DashboardChartCustomerFilter;
